export default {
  products: [],
  product: {}
}